import { EnvMicroPeople } from "lib-klab-core";

export const envPeopleLocal: EnvMicroPeople = {
    host: "/ms-people",
    apiBasePath: "",
    vars: {},
    useMocks: false,
    mock: {
        employees: {
            getAll: false,
            getById: false,
            create: false,
            update: false,
            delete: false,
            getWorkDaysById: false,
        },
        employeeHierarchies: {
            getAll: false,
            create: false,
            update: false,
            delete: false,
        },
        productivityRules: {
            getAll: false,
            getById: false,
            create: false,
            update: false,
            delete: false,
        },
        employeeConfigurations: {
            getAll: false,
            getById: false,
            update: false,
        },
        requests: {
            getAll: false,
            getById: false,
            create: false,
            update: false,
        },
    },
};

export const envPeopleDev: EnvMicroPeople = {
    host: "https://gatewayapi-dev.klab.inclub.world",
    apiBasePath: "/ms-people",
    vars: {},
    useMocks: false,
    mock: {
        employees: {
            getAll: false,
            getById: false,
            create: false,
            update: false,
            delete: false,
            getWorkDaysById: false,
        },
        employeeHierarchies: {
            getAll: false,
            create: false,
            update: false,
            delete: false,
        },
        productivityRules: {
            getAll: false,
            getById: false,
            create: false,
            update: false,
            delete: false,
        },
        employeeConfigurations: {
            getAll: false,
            getById: false,
            update: false,
        },
        requests: {
            getAll: false,
            getById: false,
            create: false,
            update: false,
        },
    },
};

export const envPeopleProd: EnvMicroPeople = {
    host: "https://gatewayapi.klab.inclub.world",
    apiBasePath: "/ms-people",
    vars: {},
    useMocks: false,
};
